// Real Delta Valley Health Club coaches — bios scraped from deltavac.com/about-us/our-coaches-and-our-mx4-coaches
// All photos mirrored to /public/images/coaches/ at 800x800 (john.jpg at 301x301 — no higher-res available).

export const COACHES = [
  {
    slug: 'andy',
    name: 'Andy',
    role: 'Fitness Director',
    image: '/images/coaches/andy.jpg',
    classes: ['MX4', 'Spin', 'TRX', 'Tabata Bootcamp', 'Personal Training', 'Group Fitness'],
    philosophy: "I have been involved in the fitness industry for over 15 years and have worked at Delta Valley Health Club for 14 years. Health and fitness are not only a personal passion of mine, but a lifestyle that everyone is capable and deserving of. I believe that working through physical challenges in the gym strengthens not only our muscles but also our resolve to conquer everyday stresses and challenges, ultimately leading to a better quality of life. I hope to inspire and support my clients in their journey to achieve their individual health and fitness goals and feel better about themselves physically and mentally. My approach to achieving and maintaining health and fitness is to be positive, happy, and grateful. Positive to encourage, happy to inspire, and grateful for the opportunity to help others change their lives.",
    certifications: [
      'SCW Certified Personal Trainer',
      'SCW Certified Group Exercise Instructor',
      'Schwinn Certified Spin Instructor',
      'TRX Certified Instructor',
      'MX4 Certified Instructor',
      'Tabata Bootcamp Certified Instructor',
    ],
  },
  {
    slug: 'heidi',
    name: 'Heidi',
    role: 'Group Fitness Instructor',
    image: '/images/coaches/heidi.jpg',
    classes: ['TRX', 'Zumba'],
    philosophy: "Heidi is a certified TRX and Zumba instructor, complementing her extensive group exercise training. While not philosophical, she believes in the mantra 'work hard, play hard,' emphasizing the correlation between effort and outcome in fitness.",
    certifications: ['TRX Certified Instructor', 'Zumba Certified Instructor'],
  },
  {
    slug: 'jenn-l',
    name: 'Jenn',
    role: 'Personal Trainer & Group Fitness Instructor',
    image: '/images/coaches/jenn-l.jpg',
    classes: ['Personal Training', 'Spin', 'WaterRower', 'TRX', 'MX4'],
    philosophy: "I strongly believe that physical and mental health are closely related and should be a priority in our lives. I encourage people to make healthy living a lifestyle and not look for a quick fix. If we enjoy what we are doing then we will find time for it and be motivated to excel to new levels we didn't think were possible. So let's put on some good music, set some goals, and crush them.",
    certifications: [
      'ACE Personal Trainer',
      'Schwinn Spin Instructor',
      'WaterRower Certified Instructor',
      'TRX Certified Instructor',
      'MX4 Certified Instructor',
    ],
  },
  {
    slug: 'pam',
    name: 'Pam',
    role: 'Yoga Instructor',
    image: '/images/coaches/pam.jpg',
    classes: ['Yoga'],
    philosophy: "For the greater part of my life, I have worked with the public and shared my passion for teaching. It is my greatest joy to share my passions with others as they dig deep into who they are and branch out into something new. Yoga has inspired me to dig deeper into the person I am supposed to be and how I am to be used to help people find their true inner selves. I am excited to give people the space to safely grow in their physical bodies and their mental bodies. This is a journey that is just taking off for me and I'm thrilled to be a part of it and share it. Even though I have just joined the Delta Valley family, I have a long history of teaching. When I am not at the gym I am in my classroom teaching children, playing golf, water skiing, or simply having fun with my family.",
    certifications: [
      'Yoga Works 200-hour Certification',
      'CPR / First Aid / AED Trained',
      "Bachelor's & Teaching Credential — CSU Hayward",
      'Golf Instructor',
    ],
  },
  {
    slug: 'david',
    name: 'David',
    role: 'Personal Trainer & MX4 Coach',
    image: '/images/coaches/david.jpg',
    classes: ['MX4', 'Functional Training', 'Personal Training'],
    philosophy: "I see myself as a fitness/sports enthusiast for a major part of my life. I have a vast background in a variety of sports — competing in individual and team sports — and over 10 years coaching experience in youth hockey. I've taught and coached children as young as 6 up to young adults in competitive travel hockey, including leading multiple Team USA Roller Hockey teams representing California. I believe I have a good understanding of working and helping people reach their goals and expectations for improvement, in both an individual or group setting. My philosophy has always been that hard, consistent work will pay off. I also feel I have a good understanding of compassion for possible limitations and strive to find ways to help people reach their goals.",
    certifications: ['Functional Training Certification', 'CPR / First Aid', 'AED Certification'],
  },
  {
    slug: 'jamir',
    name: 'Jamir',
    role: 'Personal Trainer',
    image: '/images/coaches/jamir.jpg',
    classes: ['Personal Training'],
    philosophy: "As a dedicated and passionate personal trainer, my philosophy revolves around empowering individuals to unlock their full potential and achieve their health and fitness goals. I believe in taking a holistic approach to training, addressing not only physical aspects but also considering mental and emotional well-being. My ISSA-CPT, ACE, and CPR/AED certifications equip me with the latest industry knowledge and techniques to design personalized workout programs that cater to each client's unique needs and abilities. Through continuous education and staying abreast of advancements in the fitness field, I strive to offer cutting-edge training methods that ensure maximum results and safety. My mission is to inspire and guide my clients to adopt a sustainable and balanced lifestyle, fostering lasting positive changes that extend beyond the gym, and enhancing overall well-being. Together, we will embark on a transformative journey, building strength, resilience, and confidence, one workout at a time.",
    certifications: ['ISSA Certified Personal Trainer', 'ACE Certified', 'CPR / AED'],
  },
  {
    slug: 'toni',
    name: 'Toni',
    role: 'Personal Trainer & Group Fitness Instructor',
    image: '/images/coaches/toni.jpg',
    classes: ['Spin', 'Barre', 'Body Blast', 'Personal Training', 'Group Fitness'],
    philosophy: "Health, fitness, and FUN should never be separated!! My goal is to encourage, motivate, and help those around me as they strive for the healthy and fit lifestyle they are looking for. In my classes, you will get exactly that — a fun, safe, and uplifting atmosphere where we can all come, let our cares disappear, and have an awesome workout. All fitness levels are welcome. Whether it is in Spin, Barre, or Body Blast, you will walk away feeling like the strong powerhouse that you are!",
    certifications: [
      'ExpertRating Certified Personal Trainer',
      'ExpertRating Certified Group Fitness Instructor',
      'Schwinn Certified Spin Instructor',
      'FiTour Certified Barre Instructor',
    ],
  },
  {
    slug: 'ty',
    name: 'Ty',
    role: 'MX4 Coach',
    image: '/images/coaches/ty.jpg',
    classes: ['MX4', 'Strength Training'],
    philosophy: "Coach Ty believes in unlocking potential from within, advocating that one's effort directly shapes outcomes. With this mindset, he guides members to realize their full potential, emphasizing the transformative power of hard work and dedication to achieve success.",
    certifications: ['MX4 Certified Instructor'],
  },
  {
    slug: 'lisa',
    name: 'Lisa',
    role: 'Group Fitness & MX4 Instructor',
    image: '/images/coaches/lisa.jpg',
    classes: ['MX4', 'Group Fitness', 'Functional Training'],
    philosophy: "I was always the participant in the group classes at the gyms that would envision myself up in the front of the room coordinating and instructing a class of my own one day. I'm here to help inspire, motivate, and improve the lives of everyone who walks into each of my classes. You will hear me say this often — you get one body in this life. No re-dos, no trade-ins, no returns. ONE BODY. Treat your body right, keep it healthy, fuel it with the best foods, and do it with people that you love. I'm here to make a change and help make fitness and overall well-being enjoyable and attainable for anyone.",
    certifications: ['ACE Group Fitness Certified', 'MX4 Certified Instructor', 'CPR / AED'],
  },
  {
    slug: 'john',
    name: 'John',
    role: 'Strength & Conditioning Coach',
    image: '/images/coaches/john.jpg',
    classes: ['Strength Training', 'Functional Training', 'Personal Training'],
    philosophy: "My journey into fitness began with family. As a kid I remember following calisthenics exercises off a record album jacket with my mom, and flexing biceps with my dad next to his plastic coated weights. That foundation in the value of exercise stayed with me through college and eventually a job, which led to operations manager at a large-scale commercial gym. While there, I helped many individuals reach their fitness goals, as well as my own — winning a (tested) bodybuilding contest, and second at an NPC bodybuilding competition as a novice. That experience in the fitness industry improved my own training, discipline and physical conditioning, which helped me complete a successful career in law enforcement. Today, I am still passionate about health, fitness and overall wellness. I enjoy helping people achieve their fitness goals, but moreover, I enjoy seeing people continue to make physical activity and exercise a part of their lives every day.",
    certifications: ['SCW Fitness Certification: Functional Training', '40+ years strength & cardiovascular training experience'],
  },
  {
    slug: 'sara',
    name: 'Sara',
    role: 'Personal Trainer & Nutrition Coach',
    image: null,  // No real photo — UI renders initials avatar
    classes: ['Personal Training', 'Nutrition Coaching'],
    philosophy: "Sara is a NASM Certified Personal Trainer and Nutrition Coach. She is passionate about helping clients create a life of balance that keeps them healthy and happy. Her goal is to improve your strength and balance for everyday activities and help you choose healthy alternatives when meal planning. If there is a goal you want to achieve, she will work to get you where you want to be.",
    certifications: ['NASM Certified Personal Trainer', 'NASM Certified Nutrition Coach'],
  },
  {
    slug: 'jesus',
    name: 'Jesus',
    role: 'Senior Personal Trainer',
    image: '/images/coaches/jesus.jpg',
    classes: ['Personal Training', 'Strength Training', 'Senior Fitness'],
    philosophy: "Jesus is a seasoned Personal Trainer, bringing 15 years of expertise to each session. With NSCA certification and a Bachelor of Science in Kinesiology, Jesus specializes in strength training, injury recovery, weight loss, senior and youth fitness, and mobility enhancement, empowering clients to achieve their fitness goals effectively!",
    certifications: [
      'NSCA Certified Personal Trainer',
      'B.S. Kinesiology',
      '15 years experience',
      'Senior Fitness Specialist',
      'Youth Fitness Specialist',
    ],
  },
];

// Quick lookup by slug — used by program pages to feature their coaches.
export const COACHES_BY_SLUG = Object.fromEntries(COACHES.map((c) => [c.slug, c]));

// Quick lookup by class — used by /programs/mx4, /personal-training, etc.
// Usage: getCoachesForClass('MX4') → archived coaches associated with MX4.
export const getCoachesForClass = (className) =>
  COACHES.filter((c) => c.classes.some((cl) => cl.toLowerCase() === className.toLowerCase()));
